import { useEffect } from "react";
import { useQuizStore } from "./state/store";
import { QuizScreen } from "./components/QuizScreen";
import { CompletionScreen } from "./components/CompletionScreen";
import { StatsScreen } from "./components/StatsScreen";
import { SettingsSheet } from "./components/SettingsSheet";
import { OfflineBanner } from "./components/OfflineBanner";
import { BrandMark } from "./components/BrandMark";
import { AppLoadingScreen } from "./components/AppLoadingScreen";
import { VerifyEmailBanner } from "./components/VerifyEmailBanner";

export interface AppProps {
  view: "quiz" | "stats";
}

export function App({ view }: AppProps) {
  const status = useQuizStore((s) => s.status);
  const errorMessage = useQuizStore((s) => s.errorMessage);
  const loadAll = useQuizStore((s) => s.loadAll);

  useEffect(() => {
    void loadAll();
  }, [loadAll]);

  return (
    <main className="min-h-full">
      <VerifyEmailBanner />
      <div className="mx-auto w-full max-w-2xl px-4 pb-6 sm:px-6 sm:pb-8 space-y-4 safe-top">
        <header className="flex items-center justify-between gap-3">
          <a
            href="/"
            aria-label="PPLearning — Startseite"
            data-testid="header-brand"
            className="inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-outline-strong rounded-lg"
          >
            <BrandMark variant="horizontal" className="h-7 sm:h-8 w-auto" />
          </a>
          <SettingsSheet
            trigger={
              <button
                type="button"
                className="min-h-[44px] px-3 py-2 rounded-lg text-sm text-fg-muted hover:text-fg hover:bg-card focus:outline-none focus-visible:ring-2 focus-visible:ring-outline-strong active:bg-card transition-colors inline-flex items-center gap-1.5"
                data-testid="header-menu"
                aria-label="Einstellungen und Menü"
              >
                <span aria-hidden className="text-base leading-none">⋯</span>
                <span>Menü</span>
              </button>
            }
          />
        </header>

        <OfflineBanner />

        {(status === "idle" || status === "loading") && (
          <AppLoadingScreen label="Lade Vokabeln & Fortschritt…" />
        )}
        {status === "error" && (
          <div
            className="bg-danger-soft border border-danger/40 rounded-xl px-4 py-3 text-danger"
            role="alert"
          >
            Fehler: {errorMessage}
          </div>
        )}
        {status === "ready" && view === "quiz" && <QuizScreen />}
        {status === "ready" && view === "stats" && <StatsScreen />}
        {status === "complete" && view === "quiz" && <CompletionScreen />}
        {status === "complete" && view === "stats" && <StatsScreen />}
      </div>
    </main>
  );
}
